import React from 'react';
import type { FC, ReactNode } from 'react';
import IconButton from '@mui/material/IconButton';

interface CustomIconButtonProps {
  id: string;
  icon: ReactNode;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  ariaLabel?: string;
  disabled?: boolean;
  disableRipple?: boolean;
  color?:
    | 'default'
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
  size?: 'small' | 'medium' | 'large';
  width?: '8px' | '16px' | '24px' | '32px';
  height?: '8px' | '16px' | '24px' | '32px';
  edge?: 'start' | 'end' | false;
  children?: ReactNode;
}

const CustomIconButton: FC<CustomIconButtonProps> = ({
  id,
  icon,
  onClick,
  ariaLabel,
  className,
  color = 'primary',
  disabled = false,
  disableRipple = true,
  width,
  height,
  size = 'medium',
  edge = false,
  children,
}) => {
  return (
    <IconButton
      id={id}
      onClick={onClick}
      className={className}
      aria-label={ariaLabel}
      color={color}
      disabled={disabled}
      disableRipple={disableRipple}
      sx={{ width: { width }, height: { height }, padding: '4px' }}
      size={size}
      edge={edge}
    >
      {children || icon}
    </IconButton>
  );
};

export default CustomIconButton;
